import axios from "axios";
import { notification } from "antd";
import { setLoading } from "../store/common/commonActions";
import { checkResponse } from "../utils/functions";
class RequestManager {
  // POST REQUEST
  static async postRequest(
    dispatch: any,
    url: string,
    token?: string,
    params?: any,
    customMessage?: any
  ) {
    const instance = axios.create({
      method: "post",
      url: url,
      headers: {
        Authorization: token !== "" ? "Bearer " + token : "",
        accept: "application/json",
      },
    });

    return await new Promise(function (resolve, reject) {
      instance
        .post(url, params)
        .then(function (response: any) {
          if (response.data.status === 200 || response.data.status === 201) {

            resolve(response.data);
          } else {
            dispatch(setLoading(false));
            reject(checkResponse(response?.data));

          }
        })
        .catch(function (error: any) {

          dispatch(setLoading(false));
          if (error) {
            const { response } = error;
            reject(checkResponse(response));
          }
        });
    });
  }
  // GET REQUEST
  static async getRequest(
    dispatch: any,
    url: string,
    token?: string,
    query?: string,
    header?: any,
  ) {
    let start: any = Date.now();
    const instance = axios.create({
      method: "get",
      url: url,
      headers: {
        Authorization: token !== "" ? "Bearer " + token : "",
        accept: "application/json",
      },
      // timeout: start === null ? 0 : 4000
    });

    return await new Promise(function (resolve, reject) {
      instance
        .get(query?.length ? url + query : url, header)
        .then(function (response: any) {
          resolve(response.data);
          let end = Date.now()
        })
        .catch(function (error: any) {
          // dispatch(setLoading(false));
          if(!axios.isCancel(error)){
            reject(checkResponse(error.response));
          }
          // reject(
          //     error.response.data == undefined
          //         ? 'Something went wrong. Please try again later.'
          //         : error.response.data,
          // );
        });
    });
  }
  // PUT REQUESTS
  static async putRequest(
    dispatch: any,
    url: string,
    params?: any,
    token?: string,
    id?: string,
    orgId?: any
  ) {

    const instance = axios.create({
      method: "put",
      url: url,
      headers: {
        Authorization: token !== "" ? "Bearer " + token : "",
        accept: "application/json",
      },
    });

    return await new Promise(function (resolve, reject) {
      instance
        .put(url, params)
        .then(function (response: any) {
          resolve(response.data);

        })
        .catch(function (error: any) {
          dispatch(setLoading(false));
          reject(checkResponse(error.response));
          // reject(
          //     error.response.data == undefined
          //         ? 'Something went wrong. Please try again later.'
          //         : error.response.data,
          // );
        });
    });
  }

  // PATCH REQUESTS
  static async patchRequest(
    dispatch: any,
    url: string,
    token?: string,
    id?: string,
    params?: any
  ) {
    const instance = axios.create({
      method: "patch",
      url: url,
      headers: {
        Authorization: token !== "" ? "Bearer " + token : "",
        accept: "application/json",
      },
    });

    return await new Promise(function (resolve, reject) {
      instance
        .patch(url + `/${id}`, params)
        .then(function (response: any) {
          resolve(response.data);
        })
        .catch(function (error: any) {
          dispatch(setLoading(false));
          reject(checkResponse(error.response));
          // reject(
          //     error.response.data == undefined
          //         ? 'Something went wrong. Please try again later.'
          //         : error.response.data,
          // );
        });
    });
  }

  // DELETE REQUESTS
  static async deleteRequest(
    dispatch: any,
    url: string,
    id?: any,
    token?: string,
    orgId?: string
  ) {
    const instance = axios.create({
      method: "delete",
      url: url,
      headers: {
        Authorization: token !== "" ? "Bearer " + token : "",
        accept: "application/json",
      },
    });

    return await new Promise(function (resolve, reject) {
      instance
        .delete(url + `/${id}`)
        .then(function (response: any) {
          resolve(response.status);
        })
        .catch(function (error: any) {
          dispatch(setLoading(false));
          reject(checkResponse(error.response));
          // reject(
          //     error.response.data == undefined
          //         ? 'Something went wrong. Please try again later.'
          //         : error.response.data,
          // );
        });
    });
  }
  static async formRequestParam(
    dispatch: any,
    url: any,
    params: any,
    token?: any,
    orgId?: any
  ) {
    const instance = axios.create({
      baseURL: url,
      headers: {
        "Content-Type": "multipart/form-data;",
        Authorization: token !== "" ? "Bearer " + token : "",
        accept: "application/json",
      },
    });
    return await new Promise(function (resolve, reject) {
      instance
        .post(url, params)
        .then(function (response: any) {
          resolve(response.data);
        })
        .catch(function (error: any) {
          dispatch(setLoading(false));
          reject(
            error.response === undefined
              ? "Something went wrong. Please try again later."
              : error
          );
        });
    });
  }
}

export default RequestManager;
